import React, { useCallback } from "react";
import { HiOutlineSparkles, HiX } from "react-icons/hi";
import CustomButton from "components/common/Button/CustomButton";
import { VERTEX360_COPILOT_FLOATING_INTRO } from "../constants/vertex360CopilotFloatingConstants";

const INTRO_HIGHLIGHTS = [
  "Ask questions in plain language",
  "Summarize reports and activity",
  "Navigate Vertex360 faster",
];

const stopPointerBubble = (event) => {
  event.preventDefault();
  event.stopPropagation();
};

/**
 * @param {{ onDismiss: () => void }} props
 */
const Vertex360CopilotIntroPopover = ({ onDismiss }) => {
  const handleDismiss = useCallback(
    (event) => {
      stopPointerBubble(event);
      onDismiss?.();
    },
    [onDismiss]
  );

  return (
    <div
      className="copilot-floating-intro"
      onMouseDown={stopPointerBubble}
      onClick={stopPointerBubble}
    >
      <div className="copilot-floating-intro__accent" aria-hidden="true" />

      <div className="copilot-floating-intro__top">
        <div className="copilot-floating-intro__header">
          <span className="copilot-floating-intro__icon" aria-hidden="true">
            <HiOutlineSparkles className="h-4 w-4" />
          </span>
          <div className="copilot-floating-intro__heading">
            <span className="copilot-floating-intro__eyebrow">New</span>
            <h3 className="copilot-floating-intro__title">
              {VERTEX360_COPILOT_FLOATING_INTRO.title}
            </h3>
          </div>
        </div>

        <button
          type="button"
          onClick={handleDismiss}
          onMouseDown={stopPointerBubble}
          className="copilot-floating-intro__close"
          aria-label="Dismiss introduction"
        >
          <HiX className="h-3.5 w-3.5" />
        </button>
      </div>

      <p className="copilot-floating-intro__description">
        {VERTEX360_COPILOT_FLOATING_INTRO.description}
      </p>

      <ul className="copilot-floating-intro__list">
        {INTRO_HIGHLIGHTS.map((item) => (
          <li key={item} className="copilot-floating-intro__list-item">
            <span className="copilot-floating-intro__bullet" aria-hidden="true" />
            <span>{item}</span>
          </li>
        ))}
      </ul>

      <CustomButton
        type="button"
        variant="primary"
        label={VERTEX360_COPILOT_FLOATING_INTRO.dismissLabel}
        clickHandler={handleDismiss}
        cssClass="copilot-floating-intro__cta w-full"
      />
    </div>
  );
};

export default Vertex360CopilotIntroPopover;
